import { SEARCH_INPUT_SELECTOR } from './constants';

// `SearchBar` (@fiverr-private/search_bar) keeps its query in an internal store and exposes no
// value prop. Its input is React-controlled via `onInput`, so writing through the native setter
// and dispatching an `input` event goes through the regular change flow (store + `onSearch`).
export const setSearchInputValue = (container: HTMLElement | null, text: string) => {
    // Pill variants render a differently-classed input, so fall back to the first one.
    const input =
        container?.querySelector<HTMLInputElement>(SEARCH_INPUT_SELECTOR) ??
        container?.querySelector<HTMLInputElement>('input');

    if (!input) {
        return;
    }

    const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;

    valueSetter?.call(input, text);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
};
